// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discount-container {
  padding: 20px;
  background: #0a0f1a;
  min-height: calc(100vh - 140px);
}

.header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.left-area {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.search-bar {
  width: 280px;
  padding: 10px 14px;
  border: 1px solid #2a3548;
  border-radius: 8px;
  font-size: 14px;
  background: #151e2c;
  color: #ffffff;
  transition: all 0.2s ease;
}

.search-bar::placeholder {
  color: #6b7a8f;
}

.search-bar:focus {
  outline: none;
  border-color: #b8860b;
  box-shadow: 0 0 0 3px rgba(184, 134, 11, 0.2);
  background: #1a2434;
}

.hint-text {
  color: #9ca3af;
  font-size: 13px;
}

.add-btn {
  padding: 10px 16px;
  background: #fbbf24;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  color: #0f172a;
  cursor: pointer;
  transition: transform 0.1s ease;
}

.add-btn:hover {
  transform: translateY(-1px);
}

.status-badge {
  padding: 4px 10px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 12px;
  display: inline-block;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}

.pagination button {
  padding: 8px 14px;
  border: 1px solid #2a3548;
  background: #111827;
  color: #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 30px 16px;
  z-index: 1200;
  overflow-y: auto;
}

.modal {
  background: #0f172a;
  border: 1px solid #1e293b;
  border-radius: 14px;
  width: min(720px, 100%);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  color: #e5e7eb;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #1f2937;
}

.modal-body {
  padding: 18px 20px 22px;
}

.close-btn {
  background: transparent;
  border: none;
  color: #9ca3af;
  font-size: 20px;
  cursor: pointer;
}

.detail-body {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.detail-row {
  background: #0b1324;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #1f2937;
}

.detail-row strong {
  color: #cbd5e1;
  margin-right: 6px;
}

.action-icons {
  display: flex;
  gap: 10px;
}

.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #7f8185;
}

.icon-btn:hover {
  color: #111827;
}

.icon-btn.delete {
  color: #dc2626;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Discount/List/DiscountList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".discount-container {\n  padding: 20px;\n  background: #0a0f1a;\n  min-height: calc(100vh - 140px);\n}\n\n.header-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.left-area {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.search-bar {\n  width: 280px;\n  padding: 10px 14px;\n  border: 1px solid #2a3548;\n  border-radius: 8px;\n  font-size: 14px;\n  background: #151e2c;\n  color: #ffffff;\n  transition: all 0.2s ease;\n}\n\n.search-bar::placeholder {\n  color: #6b7a8f;\n}\n\n.search-bar:focus {\n  outline: none;\n  border-color: #b8860b;\n  box-shadow: 0 0 0 3px rgba(184, 134, 11, 0.2);\n  background: #1a2434;\n}\n\n.hint-text {\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n.add-btn {\n  padding: 10px 16px;\n  background: #fbbf24;\n  border: none;\n  border-radius: 10px;\n  font-weight: 700;\n  color: #0f172a;\n  cursor: pointer;\n  transition: transform 0.1s ease;\n}\n\n.add-btn:hover {\n  transform: translateY(-1px);\n}\n\n.status-badge {\n  padding: 4px 10px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 12px;\n  display: inline-block;\n}\n\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.pagination button {\n  padding: 8px 14px;\n  border: 1px solid #2a3548;\n  background: #111827;\n  color: #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.pagination button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 30px 16px;\n  z-index: 1200;\n  overflow-y: auto;\n}\n\n.modal {\n  background: #0f172a;\n  border: 1px solid #1e293b;\n  border-radius: 14px;\n  width: min(720px, 100%);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);\n  color: #e5e7eb;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 20px;\n  border-bottom: 1px solid #1f2937;\n}\n\n.modal-body {\n  padding: 18px 20px 22px;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.detail-body {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n}\n\n.detail-row {\n  background: #0b1324;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #1f2937;\n}\n\n.detail-row strong {\n  color: #cbd5e1;\n  margin-right: 6px;\n}\n\n.action-icons {\n  display: flex;\n  gap: 10px;\n}\n\n.icon-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  color: #7f8185;\n}\n\n.icon-btn:hover {\n  color: #111827;\n}\n\n.icon-btn.delete {\n  color: #dc2626;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
